import React, {useEffect, useState} from 'react';
import './Chevron.scss';

interface ChevronProps {
    direction: 'top' | 'bottom' | 'left' | 'right';
  }

const Chevron = ({direction} : ChevronProps) => {

    const [chevronClass, setChevronClass] = useState('');

    useEffect(() => {
        switch(direction) {
            case 'top':
                setChevronClass('chevron top');
                break;
            case 'bottom':
                setChevronClass('chevron bottom');
                break;
            case 'left':
                setChevronClass('chevron left');
                break;
            case 'right':
                setChevronClass('chevron right');
                break;
            default:
                setChevronClass('chevron top');
        }
    }, [direction]);
    
  return (
    <div className={chevronClass}></div>
  )
}

export default Chevron
